import { Injectable } from '@angular/core';
import { EncFilterField, Encoding } from '@mode-vegas/vegas';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { DialogService } from '@mode/shared/ui';
import { CompiledField, CompiledFormula } from '@mode/shared/util-switch';
import { first } from 'rxjs';
import { FilterModalComponent, FilterModalData } from './filter-modal.component';

@Injectable({
  providedIn: 'root',
})
export class FilterModalService {
  private isOpen = false;

  constructor(private dialogService: DialogService) {}

  public addFilter(
    runToken: string,
    field: CompiledFormula,
    encoding: Encoding,
    view: FlamingoTypes.ModeView,
    applyFilter: (filter: EncFilterField, field: CompiledField) => void,
    onCancel: () => void = () => void 0
  ): void {
    const data: FilterModalData = {
      formula: field,
      initialFilter: undefined,
      view,
      encoding,
      queryRunToken: runToken,
      applyFilter,
      onCancel,
    };
    this.open(data);
  }

  public editFilter(
    runToken: string,
    encFilterField: EncFilterField,
    encoding: Encoding,
    view: FlamingoTypes.ModeView,
    applyFilter: (filter: EncFilterField, field: CompiledField) => void,
    onCancel: () => void = () => void 0
  ): void {
    const field = CompiledField.fromEncField(view, encFilterField);
    const data: FilterModalData = {
      formula: field,
      initialFilter: encFilterField,
      view,
      encoding,
      queryRunToken: runToken,
      applyFilter,
      onCancel,
    };
    this.open(data);
  }

  public open(data: FilterModalData): void {
    this.isOpen = true;
    const dialogRef = this.dialogService.open({
      component: FilterModalComponent,
      matDialogConfig: {
        backdropClass: 'mode-filter-modal-backdrop',
        data,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe(() => (this.isOpen = false));
  }

  public isFilterModalOpen() {
    return this.isOpen;
  }
}
